appSocial.component('leaderPerformance', {
    templateUrl: 'widgets/leader-detail/components/leader-performance/LeaderPerformanceComponent.html',
    bindings: {
        trader: '<'
    },
    controller: [
        'SocialUserService',
        'SocialLocaleService',
        'SocialUtils',
        'SocialTypes',
        'SocialAPIService',
        'SocialThemeService',
        'moment',
        class LeaderPerformanceComponent {
            constructor(
                SocialUserService,
                SocialLocaleService,
                SocialUtils,
                SocialTypes,
                SocialAPIService,
                SocialThemeService,
                moment
            ) {

                /**
                 * @type {SocialUserService}
                 */
                this.userService = SocialUserService;

                /**
                 * @type {SocialUtils}
                 */
                this.utils = SocialUtils;

                /**
                 * @type {SocialAPIService}
                 */
                this.api = SocialAPIService;

                /**
                 * @type {SocialThemeService}
                 */
                this.themeService = SocialThemeService;

                this.types = SocialTypes;

                this.moment = moment;

                this.translation = SocialLocaleService.translation;

                this.years = [
                    {
                        id: '2020',
                        label: '2020',
                    },
                    {
                        id: '2021',
                        label: '2021',
                    },
                    {
                        id: '2022',
                        label: '2022',
                    }
                ];
                this.year = this.years[this.years.length - 1];

                this.gainHistory = [];
                this.riskHistory = [];

                this.yearGain = 0;
                this.highestPerformance = null;
                this.lowestPerformance = null;
                this.highesRisk = null;
                this.lowestRisk = null;

                this.gainChartOptions = null;
                this.riskChartOptions = null;
            }

            $onInit() {
                this.update()
            }

            $onChanges(changes) {
                //console.log('trader changes', this.trader)
            }

            $onDestroy() {
            }

            getGainHistory() {
                const {HistoryGranularity} = this.types;

                const request = {
                    _url: '/' + this.trader.id,
                    from: this.moment(this.year.id).utc(true).startOf('year').unix(),
                    to: this.moment(this.year.id).utc(true).endOf('year').unix(),
                    granularity: HistoryGranularity.Monthly
                };

                return this.api.request.getGainHistory(request);
            }

            getRiskHistory() {
                const {HistoryGranularity} = this.types;

                const request = {
                    _url: '/' + this.trader.id,
                    from: this.moment(this.year.id).utc(true).startOf('year').unix(),
                    to: this.moment(this.year.id).utc(true).endOf('year').unix(),
                    granularity: HistoryGranularity.Monthly
                };

                return this.api.request.getRiskHistory(request);
            }

            update() {
                const defaultGain = {
                    gain: 0,
                    date: null,
                    trades_count: 0
                };
                const defaultRisk = {
                    risk: 0,
                    date: null,
                    trades_count: 0
                };

                Promise.all([
                    this.getGainHistory(),
                    this.getRiskHistory()
                ])
                    .then(([gainHistory, riskHistory]) => {

                        this.gainHistory = gainHistory.history
                            .map(item => {
                                return _.merge(item, {gain: item.gain * 100})
                            });

                        this.yearGain = this.gainHistory.reduce((acc, cur) => acc + cur.gain, 0);
                        this.highestPerformance = _.maxBy(this.gainHistory.filter(item => item.trades_count), 'gain') || defaultGain;
                        this.lowestPerformance = _.minBy(this.gainHistory.filter(item => item.trades_count), 'gain') || defaultGain;

                        this.riskHistory = riskHistory.history;
                        this.highestRisk = _.maxBy(this.riskHistory.filter(item => item.trades_count), 'risk') || defaultRisk;
                        this.lowestRisk = _.minBy(this.riskHistory.filter(item => item.trades_count), 'risk') || defaultRisk;

                        this.gainChartOptions = this.gainChart();
                        this.riskChartOptions = this.riskChart();
                    });
            }

            gainChart() {
                const labels = this.gainHistory.map(item => this.moment(item.date * 1000).format('MMM').toUpperCase());
                const series = this.gainHistory.map(item => item.gain.toFixed(1));

                const positiveColor = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {offset: 0, color: this.themeService.getThemeColor('leader-performance', 'colorGainChartPositive0')},
                    {offset: 1, color: this.themeService.getThemeColor('leader-performance', 'colorGainChartPositive1')},
                ]);
                const negativeColor = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {offset: 0, color: this.themeService.getThemeColor('leader-performance', 'colorGainChartNegative0')},
                    {offset: 1, color: this.themeService.getThemeColor('leader-performance', 'colorGainChartNegative1')},
                ]);
                const positiveBackground = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {offset: 0, color: this.themeService.getThemeColor('leader-performance', 'backgroundGainChartPositive0')},
                    {offset: 0.1, color: this.themeService.getThemeColor('leader-performance', 'backgroundGainChartPositive0')},
                    {offset: 1, color: this.themeService.getThemeColor('leader-performance', 'backgroundGainChartPositive1')},
                ]);

                const negativeBackground = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {offset: 0, color: this.themeService.getThemeColor('leader-performance', 'backgroundGainChartNegative0')},
                    {offset: 0.9, color: this.themeService.getThemeColor('leader-performance', 'backgroundGainChartNegative1')},
                    {offset: 1, color: this.themeService.getThemeColor('leader-performance', 'backgroundGainChartNegative1')},
                ]);

                const background = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {offset: 0, color: this.themeService.getThemeColor('leader-performance', 'backgroundGainChart0')},
                    {offset: 1, color: this.themeService.getThemeColor('leader-performance', 'backgroundGainChart1')},
                ]);

                const maxItem = _.max(this.gainHistory.map(item => Math.abs(item.gain)));
                const positiveSeries = Array(this.gainHistory.length).fill(maxItem || 50);
                const negativeSeries = Array(this.gainHistory.length).fill(-maxItem || -50);

                return {
                    grid: {
                        top: '-10%',
                        left: '0%',
                        right: '0%',
                        bottom: '30%',
                    },
                    xAxis: {
                        show: true,
                        type: 'category',
                        position: 'bottom',
                        offset: 15,
                        containLabel: true,
                        data: labels,
                        axisLabel: {
                            interval: 0,
                            color: '#929598',
                            lineHeight: 16,
                            fontSize: 11,
                            formatter: (value, index) => {
                                return [
                                    value,
                                    series[index] === '0.00' ? '-' : series[index]
                                ].join('\n');
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#cecece'
                            }
                        },
                        axisTick: {
                            show: false,
                        }
                    },
                    yAxis: {
                        show: false,
                        type: 'value'
                    },
                    series: [

                        {
                            data: positiveSeries,
                            type: 'bar',
                            barGap: '-100%',
                            itemStyle: {
                                color: positiveBackground
                            }
                        },
                        {
                            data: negativeSeries,
                            type: 'bar',
                            barGap: '-100%',
                            itemStyle: {
                                color: negativeBackground
                            }
                        },
                        {
                            data: series,
                            type: 'bar',
                            barGap: '-100%',
                            showBackground: false,
                            backgroundStyle: {
                                color: background
                            },
                            itemStyle: {
                                color: (item) => {
                                    return item.value > 0
                                        ? positiveColor
                                        : negativeColor;
                                }
                            }
                        },
                    ]
                };
            }

            riskChart() {
                const nullValue = (value) => !value ? null : value;

                const labels = this.riskHistory.map(item => this.moment(item.date * 1000).format('MMM').toUpperCase());
                const series = this.riskHistory
                    .map(item => item.risk)
                    .map(nullValue).map(item => item && item.toFixed(0));

                const seriesDelays = (series.reduce((accum, item, idx) => {
                    accum.count += !!item ? 1 : 0;
                    accum.items.push(accum.count);
                    return accum;
                }, {items: [], count: 0})).items;

                return {
                    grid: {
                        top: '10%',
                        left: '0%',
                        right: '0%',
                        bottom: '30%',
                    },
                    xAxis: {
                        show: true,
                        type: 'category',
                        position: 'bottom',
                        offset: 15,
                        data: labels,
                        axisLabel: {
                            color: '#929598',
                            lineHeight: 16,
                            fontSize: 10,
                            // margin: 8,
                            formatter: (value, index) => {
                                return [
                                    value,
                                    series[index] || '-'
                                ].join('\n');
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: 'transparent'
                            }
                        },
                        axisTick: {
                            show: false,
                        }
                    },
                    yAxis: {
                        show: false,
                        type: 'value'
                    },
                    series: [
                        {
                            animationDuration: 1000,
                            animationDelay: (idx) => (seriesDelays[idx] * 200),
                            data: series,
                            type: 'line',
                            symbol: 'circle',
                            symbolSize: 15,
                            connectNulls: false,
                            lineStyle: {
                                color: this.themeService.getThemeColor('leader-performance', 'lineRiskChart'),
                                width: 1,
                                type: 'solid'
                            },
                            itemStyle: {
                                // borderWidth: 5, // this.viewStateService.state.theme.name === 'dark-monokai' ? 0 : 1,
                                // borderColor: '#ff0000',
                                color: (item) => {
                                    if (item.value <= 3) {
                                        return this.themeService.getThemeColor('leader-performance', 'colorRiskLow');
                                    }
                                    if (item.value <= 6) {
                                        return this.themeService.getThemeColor('leader-performance', 'colorRiskMiddle');
                                    }
                                    return this.themeService.getThemeColor('leader-performance', 'colorRiskHigh');
                                },
                                shadowBlur: 1,
                                shadowColor: 'rgba(0,0,0,0.3)',
                            },
                            label: {
                                show: true,
                                position: 'inside',
                                formatter: '{c}',
                                color: this.themeService.getThemeColor('leader-performance', 'colorLabel'),
                            }
                        }
                    ]
                };
            }

            getRisk(score) {
                return this.utils.getRisk(score);
            }
        }]
})
